<template>
    <HeaderComponent/>
    <section class="w-full h-[400px] lg:h-[500px] mt-[70px] relative flex justify-center items-center">
        <div class="w-full absolute top-0 left-0 h-full flex justify-center items-center overflow-hidden">
            <img src="../assets/images/stylish.jpg" alt="" class="w-full h-full absolute object-cover object-right">
        </div>
        <div class="w-full h-full absolute bg-black/50 top-0 left-0 flex justify-center items-center">
            <div class="container lg:max-w-[1200px] px-[20px] w-full relative flex flex-col justify-center items-center">
                <h1 class="text-center text-2xl font-bold text-white ">
                    Pomme City
                </h1>
                <p class="max-w-[600px] px-[20px] text-center md:text-lg my-[10px] text-sm font-semibold text-gray-200">
                    Tout ce Dont Vous Avez Besoin pour Votre Smartphone : iOS, Android et Plus Encore
                </p>
                <button @click="gotoBoutique()" class="p-[10px] rounded-[5px] text-sm font-bold bg-orange-600 text-gray-100">
                    Acheter maintenant
                </button>
            </div>
        </div>
    </section>
    <section class="w-full relative flex justify-center my-[100px] items-center">
        <div class="container lg:max-w-[1200px] flex px-[20px] w-full relative justify-center items-center flex-col">
            <div class="w-full md:h-[400px] flex gap-6 md:justify-between justify-center md:flex-row flex-col items-center relative">
                <div @click="gotoBoutique()" class=" cursor-pointer rounded-[10px] mt-[20px] md:mt-0 w-full md:h-full h-[150px] bg-[#F2F2F2] flex justify-center items-center md:flex-col flex-row relative">
                    <div class="md:w-full w-6/12 md:h-[30%] h-full relative flex flex-col justify-center items-center md:pt-[20px] md:pb-[50px] pl-[20px]">
                        <h1 class="text-2xl font-bold text-gray-800 w-full md:w-auto uppercase">Iphone</h1>
                        <p class="text-xs capitalize text-gray-500 w-full md:w-auto font-bold">Tous les iphone de la 7</p>
                    </div>
                    <div class="md:w-full w-6/12 md:h-[70%] h-full relative flex justify-center items-center overflow-hidden">
                        <img src="../assets/images/categorie_iphone.png" alt="" class="w-full h-full absolute object-contain object-center">
                    </div>
                </div>
                <div @click="gotoBoutique()" class=" cursor-pointer rounded-[10px] w-full md:h-full h-[150px] bg-[#DAEEEF] flex justify-center items-center md:flex-col mt-[20px] md:mt-0">
                    <div class="w-6/12 h-full md:h-[30%] md:w-full relative flex flex-col justify-center items-center md:pl-[50px] pl-[20px]">
                        <h1 class="text-2xl font-bold text-gray-800 md:text-center w-full uppercase">Android</h1>
                        <p class="text-xs capitalize md:text-center text-gray-500 w-full font-bold">Tous les Android disponibles</p>
                    </div>
                    <div class="w-6/12 h-full md:h-[70%] md:w-full relative flex justify-center items-center overflow-hidden">
                        <img src="../assets/images/categorie_samsung.png" alt="" class="w-full h-full absolute object-contain object-center">
                    </div>
                </div>
                <div @click="gotoBoutique()" class="w-full rounded-[10px] md:h-full h-[150px] bg-[#F3F2F0] flex flex-center items-center md:flex-col flex-row relative  md:mt-0">
                    <div class="md:w-full w-[50%] md:h-[35%] h-full relative flex flex-col justify-center items-center py-[20px]">
                        <h1 class="text-2xl font-bold text-gray-800 md:text-center w-full uppercase">Accessoires</h1>
                        <p class="text-sm capitalize text-gray-500 font-bold max-w-[80%] md:text-center text-left">Vos différents accessoires sont disponibles</p>
                    </div>
                    <div class="md:w-full w-[50%] md:h-[70%] h-full relative flex justify-center items-center overflow-hidden">
                        <img src="../assets/images/rendering.jpg" alt="" class="w-full h-full absolute object-cover object-center">
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="my-[50px] py-[50px] w-full relative hidden justify-center items-center">
        <div class="container lg:max-w-[1200px] px-[20px] flex flex-col justify-center items-center relative w-full">
            <div class="w-full relative flex justify-start items-start flex-col md:mb-[40px]">
                <div class="flex items-center">
                    <div class="w-[25px] h-[25px] rounded-full flex justify-center items-center text-white bg-blue-500">
                        <i class="fa-solid fa-layer-group text-sm"></i>
                    </div>
                    <h1 class="ml-[5px] text-sm font-bold uppercase text-blue-500">Toutes les catégories</h1>
                </div>
                <h1 class="text-2xl font-bold text-gray-800">
                    Parcourir par catégorie
                </h1>
            </div>
            <div class="w-full relative md:hidden flex justify-end items-center my-[20px]">
                <button class="w-[35px] h-[35px] rounded-full bg-gray-200 flex justify-center items-center text-gray-800 text-sm font-bold mx-[20px]"><i class="fa-solid fa-chevron-left"></i></button>
                <button class="w-[35px] h-[35px] rounded-full bg-gray-200 flex justify-center items-center text-gray-800 text-sm font-bold"><i class="fa-solid fa-chevron-right"></i></button>
            </div>
            <div class="parent flex w-full md:justify-between justify-start overflow-x-auto items-center relative">
                <div class="m-[10px] mx-[25px] ml-0 flex flex-col justify-center items-center">
                    <div class="flex justify-center items-center w-[75px] h-[75px] min-w-[75px] min-h-[75px] rounded-full bg-gray-100 ">
                        <img src="../assets/logo.png" alt="" class="w-[30px] h-[30px]">
                    </div>
                    <h1 class="text-sm font-bold text-gray-800 my-[5px]">Iphone</h1>
                    <p class="text-xs font-semibold text-gray-500">20 produits</p>
                </div>
                <div class="m-[10px] mx-[25px] flex flex-col justify-center items-center">
                    <div class="flex justify-center items-center w-[75px] h-[75px] min-w-[75px] min-h-[75px] rounded-full bg-gray-100 ">
                        <img src="../assets/logo.png" alt="" class="w-[30px] h-[30px]">
                    </div>
                    <h1 class="text-sm font-bold text-gray-800 my-[5px]">Iphone</h1>
                    <p class="text-xs font-semibold text-gray-500">20 produits</p>
                </div>
                <div class="m-[10px] mx-[25px] flex flex-col justify-center items-center">
                    <div class="flex justify-center items-center w-[75px] h-[75px] min-w-[75px] min-h-[75px] rounded-full bg-gray-100 ">
                        <img src="../assets/logo.png" alt="" class="w-[30px] h-[30px]">
                    </div>
                    <h1 class="text-sm font-bold text-gray-800 my-[5px]">Iphone</h1>
                    <p class="text-xs font-semibold text-gray-500">20 produits</p>
                </div>
                <div class="m-[10px] mx-[25px] flex flex-col justify-center items-center">
                    <div class="flex justify-center items-center w-[75px] h-[75px] min-w-[75px] min-h-[75px] rounded-full bg-gray-100 ">
                        <img src="../assets/logo.png" alt="" class="w-[30px] h-[30px]">
                    </div>
                    <h1 class="text-sm font-bold text-gray-800 my-[5px]">Iphone</h1>
                    <p class="text-xs font-semibold text-gray-500">20 produits</p>
                </div>
                <div class="m-[10px] mx-[25px] flex flex-col justify-center items-center">
                    <div class="flex justify-center items-center w-[75px] h-[75px] min-w-[75px] min-h-[75px] rounded-full bg-gray-100 ">
                        <img src="../assets/logo.png" alt="" class="w-[30px] h-[30px]">
                    </div>
                    <h1 class="text-sm font-bold text-gray-800 my-[5px]">Iphone</h1>
                    <p class="text-xs font-semibold text-gray-500">20 produits</p>
                </div>
                <div class="m-[10px] mx-[25px] mr-0 flex flex-col justify-center items-center">
                    <div class="flex justify-center items-center w-[75px] h-[75px] min-w-[75px] min-h-[75px] rounded-full bg-gray-100 ">
                        <img src="../assets/logo.png" alt="" class="w-[30px] h-[30px]">
                    </div>
                    <h1 class="text-sm font-bold text-gray-800 my-[5px]">Iphone</h1>
                    <p class="text-xs font-semibold text-gray-500">20 produits</p>
                </div>
            </div>
        </div>
    </section>
    <section class="py-16 w-full mt-[50px] bg-gray-900">
        <div class="container lg:max-w-[1200px] px-5 mx-auto">
            <div class="flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-12">
                <!-- Titre section -->
                <div class="w-full md:w-1/4">
                    <div class="flex items-center mb-3">
                        <div class="w-8 h-8 rounded-full flex justify-center items-center text-white bg-blue-500">
                            <i class="fas fa-chart-line text-sm"></i>
                        </div>
                    <h2 class="ml-3 text-sm font-bold uppercase tracking-wider text-blue-300">Nos produits</h2>
                </div>
                <h1 class="text-2xl md:text-3xl font-bold text-white mb-2">Les plus vendus</h1>
                <p class="text-gray-300 text-sm">Découvrez nos produits les plus populaires</p>
            </div>

            <!-- Carrousel -->
            <div class="w-full md:w-3/4">
                <CarouselMost />
            </div>
        </div>
      </div>
    </section>
    <section class="my-16 w-full relative">
        <div class="container lg:max-w-[1200px] px-5 mx-auto">
            <!-- En-tête -->
            <div class="text-center mb-12">
                <div class="inline-flex items-center mb-4 px-4 py-2 bg-blue-50 rounded-full">
                    <div class="w-6 h-6 rounded-full flex justify-center items-center text-white bg-blue-500">
                        <i class="fas fa-gift text-xs"></i>
                    </div>
                    <h2 class="ml-2 text-sm font-bold uppercase text-blue-500">Nos offres promotionnelles</h2>
                </div>
                <h1 class="text-3xl font-bold text-gray-800 mb-2">Découvrez nos offres exceptionnelles</h1>
                <p class="text-gray-500 max-w-2xl mx-auto">Profitez de nos meilleures promotions sur une sélection de produits</p>
            </div>

            <!-- Grille des produits -->
            <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                <router-link 
                    v-for="(offre, index) in produits" 
                    :key="index" 
                    :to="'/boutique/produits/'+ offre._id"
                    class="group bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100"
                >
                    <!-- Image du produit -->
                    <div class="relative h-48 bg-gray-50 overflow-hidden">
                        <img 
                            :src="offre.photos[0] || '/img/default.png'" 
                            :alt="offre.lotName" 
                            class="w-full h-full object-contain p-4 transition-transform duration-500 group-hover:scale-105"
                            @error="handleImageError"
                        >
                        <!-- Badge de promotion -->
                        <div v-if="offre.prix !== offre.prix_reduit" class="absolute top-3 right-3 bg-orange-500 text-white text-xs font-bold px-2 py-1 rounded-lg">
                            -{{ Math.round((offre.prix - offre.prix_reduit) / offre.prix * 100) }}%
                        </div>
                    </div>

                    <!-- Détails du produit -->
                    <div class="p-4 relative">
                        <h3 class="text-sm font-semibold text-gray-800 mb-1 group-hover:text-orange-500 transition-colors truncate">
                            {{ offre.lotName }}
                        </h3>

                        <!-- Prix -->
                        <div class="flex items-baseline mt-2">
                            <span class="text-lg font-bold text-orange-500">{{ formatPrice(offre.prix_reduit) }}</span>
                            <span v-if="offre.prix !== offre.prix_reduit" class="ml-2 text-sm text-gray-400 line-through">
                                {{ formatPrice(offre.prix) }}
                            </span>
                        </div>

                        <!-- Évaluation -->
                        <div class="flex items-center mt-3">
                            <div class="flex text-orange-400 mr-2">
                                <i class="fas fa-star text-xs"></i>
                                <i class="fas fa-star text-xs ml-0.5"></i>
                                <i class="fas fa-star text-xs ml-0.5"></i>
                                <i class="fas fa-star text-xs ml-0.5"></i>
                                <i class="fas fa-star-half-alt text-xs ml-0.5"></i>
                            </div>
                            <span class="text-xs text-gray-500">(24)</span>
                        </div>
                    </div>
                </router-link>
            </div>

            <!-- Chargement -->
            <div v-if="isLoading" class="w-full min-h-[200px] flex justify-center items-center">
                <div class="spinner"></div>
            </div>

            <!-- Bouton Voir plus -->
            <div class="text-center mt-10">
                <button 
                    @click="gotoBoutique()" 
                    class="inline-flex items-center px-6 py-3 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-orange-500 hover:bg-orange-600 transition-colors"
                >
                    Voir toutes les offres
                    <i class="fas fa-arrow-right ml-2"></i>
                </button>
            </div>
        </div>
    </section>
    <section class="my-[50px] py-[50px] w-full relative flex justify-center bg-gray-800 items-center">
        <div class="w-full flex justify-center items-center lg:max-w-[1200px] px-[20px] relative">
            <div class="w-full relative flex md:h-[300px] h-auto justify-center items-center md:flex-row flex-col">
                <div class="md:w-6/12 w-full md:h-full h-[300px] relative flex justify-center items-center overflow-hidden">
                    <img src="../assets/images/iphone15.png" alt="" class="w-full h-full absolute object-contain object-center">
                </div>
                <div class="md:w-6/12 w-full h-full relative flex flex-col items-start">
                    <h1 class="text-3xl font-bold text-white uppercase">Iphone 15 Pro max titanium</h1>
                    <div class="w-full flex justify-start items-center flex-wrap my-[25px]">
                        <div class="w-[90px] h-[90px] mr-[20px] my-[10px] bg-gray-200 flex items-center justify-center relative overflow-hidden rounded-[5px]">
                            <img src="../assets/images/iphone15.png" alt="" class="w-[90%] h-[90%] absolute object-contain object-center">
                        </div>
                        <div class="w-[90px] h-[90px] mr-[20px] my-[10px] bg-gray-200 flex items-center justify-center relative overflow-hidden rounded-[5px]">
                            <img src="../assets/images/iphone15_1.png" alt="" class="w-[90%] h-[90%] absolute object-contain object-center">
                        </div>
                        <div class="w-[90px] h-[90px] mr-[20px] my-[10px] bg-gray-200 flex items-center justify-center relative overflow-hidden rounded-[5px]">
                            <img src="../assets/images/iphone15_2.png" alt="" class="w-[90%] h-[90%] absolute object-contain object-center">
                        </div>
                        <div class="w-[90px] h-[90px] mr-[20px] my-[10px] bg-gray-200 flex items-center justify-center relative overflow-hidden rounded-[5px]">
                            <img src="../assets/images/iphone15_3.png" alt="" class="w-[90%] h-[90%] absolute object-contain object-center">
                        </div>
                    </div>
                    <button class="bg-gray-200 text-gray-600 font-bold text-sm rounded-[5px] p-[10px] w-auto">Achetez maintenant</button>
                </div>
            </div>
        </div>
    </section>
    <section class="my-[50px] py-[50px] flex items-center justify-center w-full bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
        <div class="absolute top-0 left-0 w-full h-[5px] bg-gradient-to-r from-orange-400 to-orange-700"></div>
        
        <div class="container lg:max-w-[1200px] px-[20px] w-full relative">
            <div class="text-center mb-[50px]">
                <span class="text-xs font-semibold text-orange-600">TÉMOIGNAGES</span>
                <h1 class="text-2xl md:text-3xl font-bold text-gray-800 mt-2">Ce que nos clients disent <span class="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-orange-600">de nous</span></h1>
                <div class="w-20 h-1 mx-auto mt-4 bg-gradient-to-r from-orange-400 to-orange-500 rounded-full"></div>
            </div>

            <div class="w-full relative">
                <CarouselAvis/>

                <!-- Éléments décoratifs -->
                <div class="hidden lg:block absolute -left-10 top-1/4 text-gray-200 text-8xl z-0">"</div>
                <div class="hidden lg:block absolute -right-10 bottom-1/4 text-gray-200 text-8xl z-0">"</div>
            </div>
        </div>
    </section>

    <FooterComponent/>

</template>

<script setup>
import HeaderComponent from '../components/HeaderComponent.vue'
import CarouselMost from '../components/CarouselMost.vue'
import CarouselAvis from '../components/CarouselAvis.vue'
import { onMounted, ref } from 'vue'
import FooterComponent from '@/components/FooterComponent.vue'
import axios from 'axios'
import { useRouter } from 'vue-router'

const router = useRouter()

function gotoBoutique() {
    router.push("/boutique")
}

const defaultImage = '/img/default.png'

// Données (à remplacer par vos props ou store)
const produits = ref([])
const isLoading = ref(false)

const handleImageError = (event) => {
  event.target.src = defaultImage
}

const formatPrice = (price) => {
  return new Intl.NumberFormat('fr-FR').format(price) + ' FCFA'
}


const fetchProduits = async () => {
  try {
    isLoading.value = true;
    const response = await axios.get(`/api/lots/produits/random`);
    produits.value = response.data
    .filter(produit => produit.isOnline) 
    .map(produit => {
      const { prix, prix_reduit } = produit;
      const reductionPercentage = prix_reduit ? Math.floor(((prix - prix_reduit) / prix) * 100) : 0;
      return {
        ...produit,
        reductionPercentage: reductionPercentage, // Pourcentage arrondi à deux décimales
      };
    });
  } catch (err) {
    console.error('Erreur lors du chargement des produits:', err);
  } finally {
    isLoading.value = false;
  }
};


onMounted(() => {
    fetchProduits()
})
</script>
<style scoped>
/* Style du loader */
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: rgb(234, 88, 12);
  animation: spin 1s ease infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
